<div [style.display]="isVisible() ? 'flex' : 'none'" class="photo-wrapper" [id]="htmlId()">
  @if (isCommentPhotoItem()) {
    <div [id]="'user_' + htmlId()">[{{ userNameTrimmed() }}]</div>
  }

  @if (isDesktopDevice()) {
    @if (showPhotoMenu()) {
      <div class="menu-backdrop" (click)="showPhotoMenu.set(false)"></div>
    }
    <div class="photo-menu-container">
      <button
        type="button"
        role="button"
        class="photo-opener"
        (click)="onPhotoMenuClick($event)"
        [disabled]="formControl?.disabled">
        <div class="icon-safe-zone">
          <mat-icon class="icon">photo_camera</mat-icon>
        </div>
        <span [ngClass]="[properties.style.toLowerCase(), 'no-style-background']">{{ properties.text }}</span>
        <mat-icon class="dropdown-icon">{{ showPhotoMenu() ? 'expand_less' : 'expand_more' }}</mat-icon>
      </button>
      @if (showPhotoMenu()) {
        <div class="photo-menu">
          <button type="button" class="menu-item" (click)="onCaptureClick($event)">
            <mat-icon>videocam</mat-icon>
            <span>{{ translateService.instant('liveforms-editor.photo-item.menu.capture') }}</span>
          </button>
          <button type="button" class="menu-item" (click)="onSelectFileClick($event)">
            <mat-icon>folder_open</mat-icon>
            <span>{{ translateService.instant('liveforms-editor.photo-item.menu.select-file') }}</span>
          </button>
        </div>
      }
    </div>
  } @else {
    <button
      type="button"
      role="button"
      class="photo-opener"
      [disabled]="formControl?.disabled"
      (click)="onPhotoOpenClick($event)">
      <div class="icon-safe-zone">
        <mat-icon class="icon">photo_camera</mat-icon>
      </div>
      <span [ngClass]="[properties.style.toLowerCase(), 'no-style-background']">{{ properties.text }}</span>
    </button>
  }

  <input #fileInput type="file" (change)="onFileChange($event)" class="file-input" />

  @if (!isGalleryFirstLoaded()) {
    <div class="photo-gallery" draggable="false">
      @for (item of Array(itemsLoadingCount()); track $index) {
        <div [ngClass]="{ 'photo-skeleton': !isLoaded(item) && !isErrored(item) }"></div>
      }
    </div>
  } @else {
    <div class="photo-gallery" draggable="false">
      @for (item of displayGalleryItems(); track item.resourceData.fileId) {
        <div
          [ngClass]="{
            'photo-skeleton': !isLoaded(item) && !isErrored(item),
            'photo-errored': isErrored(item)
          }">
          @if (isErrored(item)) {
            <mat-icon size="6">broken_image</mat-icon>
            <div>
              {{
                translateService.instant('liveforms-editor.photo-item.image.error', {
                  filename: item.resourceData.fileId
                })
              }}
            </div>
          } @else {
            <img
              class="photo-item"
              [ngClass]="{
                'photo-item-loaded': isLoaded(item),
                'photo-item-loading': !isLoaded(item) && !isErrored(item)
              }"
              [id]="'photo_' + item.resourceData.fileId"
              [src]="item.src || ''"
              [alt]="item.resourceData.fileId"
              draggable="false"
              (load)="setItemAsLoaded(item)"
              (error)="setItemAsErrored(item)"
              (click)="onThumbnailClick($event, item)" />
          }
        </div>
      }
    </div>
  }
</div>
